/*
  Docs about filtering in the Pimcore:
  https://pimcore.com/docs/6.x/Development_Documentation/Web_Services/Query_Filters.html
*/

import { Filter } from './types';

export function exact(field: string, value: string | number): Filter {
  return {
    [field]: value,
  };
}

export function gte(field: string, value: number | string): Filter {
  return {
    [field]: {
      $gte: value,
    },
  };
}

export function lte(field: string, value: number | string): Filter {
  return {
    [field]: {
      $lte: value,
    },
  };
}

export function gt(field: string, value: number | string): Filter {
  return {
    [field]: {
      $gt: value,
    },
  };
}

export function lt(field: string, value: number | string): Filter {
  return {
    [field]: {
      $lt: value,
    },
  };
}

export function like(field: string, value: number | string): Filter {
  return {
    [field]: {
      $like: value,
    },
  };
}

export function not(field: string, value: number | string): Filter {
  return {
    [field]: {
      $not: value,
    },
  };
}

export function or(...filters: Filter[]) {
  return {
    $or: [...filters],
  };
}

export function and(...filters: Filter[]) {
  return {
    $and: [...filters],
  };
}
